import { render, staticRenderFns } from "./Pflegebericht.vue?vue&type=template&id=6646b6a0&"
import script from "./Pflegebericht.vue?vue&type=script&lang=js&"
export * from "./Pflegebericht.vue?vue&type=script&lang=js&"
import style0 from "./Pflegebericht.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports